<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

// The page title is rendered by AppHeader from the same route meta.
const pageDescription = computed(() => {
  const value = route.meta.pageDescription;
  return typeof value === "string"
    ? value
    : "This landing-page sprint keeps the destination warm with a clear placeholder.";
});
</script>

<template>
  <div class="page-main-container gap-5">
    <section class="dashboard-card dashboard-page rounded-[1.5rem] px-6 py-10">
      <p
        class="dashboard-text-link text-xs font-semibold tracking-[0.18em] uppercase"
      >
        Landing page MVP placeholder
      </p>
      <p class="dashboard-text-secondary mt-4 max-w-3xl text-sm leading-6">
        {{ pageDescription }}
      </p>
      <div class="mt-6 flex flex-wrap gap-3">
        <RouterLink
          :to="{ name: 'dashboard-overview' }"
          class="dashboard-link-button rounded-xl px-4 py-2 text-sm font-semibold no-underline"
        >
          Return to Overview
        </RouterLink>
        <RouterLink
          :to="{ name: 'search-select-pos' }"
          class="dashboard-control dashboard-text-secondary rounded-xl px-4 py-2 text-sm font-semibold no-underline transition"
        >
          Open PO Recommendations
        </RouterLink>
      </div>
    </section>
  </div>
</template>
